import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the elements
 *
 * @returns {object} the result data
 */
/* export default async function getElements () {
  return await fetchJSONData(
    `${constants.API_URL}/nft_element/elements?company_id=${constants.API_ID}&network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'company-id': constants.API_ID
      }
    }
  )
} */

/**
 *
 */
export default async function getElements () {
  return await fetchJSONData(
    `${constants.API_V2_URL}/frontend/nft_elements/elements?company-id=${constants.API_ID}&network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )
}
